var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.axios_errored == false)?_c('div',_vm._l((_vm.page_api_data),function(data){return _c('div',{key:data.id,staticClass:"wordpress-page-api-content",domProps:{"innerHTML":_vm._s(data.content.rendered)}})}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }